export const gkFormUrl = "https://readdy.ai/api/form/dae18c1tto0ceqqngnhg";